import React from 'react';
import { Box, Typography, TextField, Chip } from '@mui/material';

interface SkillsProps {
  skills: string;
  setSkills: (skills: string) => void;
}

const Skills: React.FC<SkillsProps> = ({ skills, setSkills }) => {
    const tokens = skills
    .split(",")
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, 50);

    return (
        <Box>
          <TextField
            label="Your skills (comma separated)"
            value={skills}
            onChange={(e) => setSkills(e.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
          {tokens.length > 0 ? (
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
              {tokens.map((s, idx) => (
                <Chip key={`${s}-${idx}`} label={s} size="small" />
              ))}
            </Box>
          ) : (
            <Typography variant="caption" color="text.secondary">
              Example: React, Leadership, Data Analysis
            </Typography>
          )}
        </Box>
      );
};

export default Skills;